<!-- ⚠️ NZSC-3477: 이 라우트는 naezipscan-web-core(Next.js)가 서빙 중 (2026-08-05 컷오버, NZSC-3404/3410).
  이 파일은 롤백 안전망(vercel.json rewrite revert 복귀 경로)이라 삭제 금지 — 여기를 고쳐도 유저에게 안 보인다.
  화면 수정은 web-core에서. 정본 = playbook work-contexts/20260803-007, 감시 = web-core scripts/check-web-sync.py -->
<template>
    <div >
        <article class="main report_main">      
            <header style="text-align:center;padding:44px 18px 48px 18px;position: fixed;display: flex;">
                

                <div style="margin:auto;"></div>
                <div class="header_title" style="margin:auto;margin-left: 13px;">
                    <img src="@/assets/images/report/feed_logo.svg" >
                </div>
                <div style="cursor: pointer;" class="header_title" @click="fnCopy">
                    <img style="float:right;" src="@/assets/images/report/feed_share.svg">
                </div>
            </header>                       
            <section>              
                <div class="paid_report_content">         
                    <div class="tab-content tab2 current" style="background:#fff;">
                        <div class="paid_report_box content_type02" style="display:flex">
                            <img src="@/assets/images/report/logo_assortment_red.svg">
                            <span class="free_report_span_box" style="margin-left:16px;">                             
                                전세사기 예방하려면<br>
                                <b style="font-weight: 900;font-size: 19px;color:#FF5A56;">반드시 알아야 하는 TIP</b>
                            </span>
    
                        </div>
                    
                        <div class="paid_report_box content_type02 paid_report_datail">

                            <p style="font-size:18px;font-weight: 700; color:#2B2B2B;width:100%;text-align: left;">전세사기를 피하려면</p>
                            <p style="font-size:18px;font-weight: 700; color:#2B2B2B;text-align: left;">
                                <span class="red_line">주기적으로 봐야하는 등기부등본!</span>        
                            </p>   

                            <img src="@/assets/images/feed/charter_04.svg">
                            <div class="paid_txt" style="text-align: left;margin-top: 32px;">
                                <p style="margin-top:22px;font-weight: 500;font-size: 14px;color:#2B2B2B">
                                    최근 전세사기 사고액이 급격하게 증가하고 있습니다. 부동산 전문가 및 변호사들은 
                                    전세사기를 예방하기 위해 수시로 등기부등본을 확인하는 것이 중요하다고 하는데요,
                                </p>
                                <p style="margin-top:22px;font-weight: 500;font-size: 14px;color:#2B2B2B">
                                    왜 부동산 전문가들은 등기부등본을 주기적으로 확인하라고 할까요?                      
                                </p>
                            </div>

                            <img src="@/assets/images/report/paid_report_datail03.svg" style="margin-top:25px;">
                            <p style="margin-top:22px;font-weight: 500;font-size: 14px;color:#2B2B2B;text-align: left;">
                                <b style="color:#FF5A56">1.</b> <span class="red_line">전세사기를 미리 예측해 볼 수 있어요!</span>
                            </p>

                            <p style="margin-top:22px;font-weight: 500;font-size: 14px;color:#2B2B2B;text-align: left;">
                                등기부등본에는 우리 집 임대인이 누구인지, 빚은 얼마나 받았는지, 위험한 권리관계는 없는지 등의 확인이 가능합니다.
                            </p>            
                            <p style="margin-top:22px;font-weight: 500;font-size: 14px;color:#2B2B2B;text-align: left;">
                                뿐만 아니라 집주인이 빚을 더 받거나, 집을 팔게 되면 이러한 이력들은 모두 등기부등본에 적히게 됩니다.
                            </p>      
                            <p style="margin-top:22px;font-weight: 500;font-size: 14px;color:#2B2B2B;text-align: left;">
                                따라서 만약 집주인이 내가 계약한 이후 빚을 계속 더 받거나, 세금을 내지 못해 압류 등이 생기게 된다면 
                                내 보증금을 돌려주기 어려운 상황이라고 미리 예측해 볼 수 있어요!
                            </p>     

                            <p style="margin-top:22px;font-weight: 500;font-size: 14px;color:#2B2B2B;text-align: left;">
                                <b style="color:#FF5A56">2.</b> <span class="red_line">때로는 사기를 예방할 수도 있습니다.</span>
                            </p>

                            <p style="margin-top:22px;font-weight: 500;font-size: 14px;color:#2B2B2B;text-align: left;">
                                만약 집주인이 나에게 아무 말도 없이 바지 사장 등 전세사기꾼에게 
                                집을 팔아 임대인이 바뀐 경우라면, 상황에 따라 승계 거부 소송 등을 준비해 볼 수도 있습니다. 
                            </p> 
                            <p style="margin-top:22px;font-weight: 500;font-size: 14px;color:#2B2B2B;text-align: left;">
                                뿐만 아니라 집에 위험한 권리관계가 생겼을 경우 보험사, 은행사에 미리 얘기하여 대출 연장 신청을 함으로써  
                                금전적 피해를 최소화할 수 있다는 점에서도 등기부등본을 자주 보는 것은 매우 중요합니다.
                            </p> 


                            <img src="@/assets/images/report/paid_report_datail05.svg" style="margin-top:28px;">
                            <div class="paid_txt" style="text-align: left;margin-top: 20px;">
                                <div class="paid_txt_tit">
                                    <span>그럼 등기부등본을 계속 뽑아봐야 하나요?</span>                            
                                </div>
                                <p style="margin-top:22px;font-weight: 500;font-size: 14px;color:#2B2B2B">
                                    계약 도중 등기부등본을 자주 확인해 보는 것은 매우 중요하기 때문에 가능하다면 주기적으로 확인해 보는 것이 좋습니다.
                                </p>
                                <p style="margin-top:22px;font-weight: 500;font-size: 14px;color:#2B2B2B">
                                    뿐만 아니라 등기부등본상 변동 사항이 발생했다면 이 변동사항이 위험한 것인지 아닌지 확인해야 하고,
                                    <span class="red_line"> 위험한 상황이라면 어떻게 대처</span>
                                    하는지도 알아야 합니다.
                                </p>
                                <p style="margin-top:22px;font-weight: 500;font-size: 14px;color:#2B2B2B">
                                    다만 등기부등본은 발급할때 마다 700원이라는 비용이 발생합니다. 이렇다 보니 매일 등기부등본을 발급하게 되면              
                                    <span class="red_line"> 한 달에 20,000원이 넘는 부담스러운 비용이 발생</span>  
                                    할 뿐 아니라, 매일 등기부등본 파일을 비교해 가며 직접 변동사항을 찾아야 함으로 매우번거로울 수 있습니다.             
                                </p>
                                <p style="margin-top:22px;font-weight: 500;font-size: 14px;color:#2B2B2B">
                                    이에              
                                    <span class="red_line"> 내집스캔에서는 월 3,900원의 구독료로 등기부등본 변동 내역을 대신 확인해주는 구독 서비스</span>  
                                    를 진행하고 있습니다. 실제 은행 및 보증보험사에서도 전세사기를 추적하기 위해 활용하는 방식으로  
                                    등기부등본을 주기적으로 대신 확인하여 변동사항을 알려줄 뿐 아니라, 
                                    문제 발생 시 최적의 대처 방안을 알려주는 전세사기 리포트를 매달 제공하고 있습니다. 
                                </p>
                                <p style="margin-top:22px;font-weight: 500;font-size: 14px;color:#2B2B2B">
                                    따라서 주기적으로 등기부등본을 확인하기 어렵거나, 부동산 전문지식이 부족하다면 
                                    전세사기 알리미 구독 서비스를 통해 편하게 전세사기를 예측 및 예방할 수 있습니다!
                                </p>
                            </div>

                        

                        </div>


                        


                        <div class="paid_report_box content_type02 paid_report_datail" style="margin-bottom: 15vh;">
                            <img src="@/assets/images/feed/charter_02.svg" style="margin:10px 0 0 0;">
                            <p style="font-size:20px;font-weight: 600; color:#3E3E3E;width:100%;text-align: center;margin-top:16px;">
                                매달 받아보는 우리 집
                            </p>
                            <p style="font-size:20px;font-weight: 600; color:#3E3E3E;text-align: center;">
                                전세사기 알리미
                            </p>                        

                            <img src="@/assets/images/feed/charter_05.svg">
                            <img src="@/assets/images/feed/charter_06.svg">
                            <button class="btn_blue_b" @click="fnOrder" style="margin-top:0vh;">
                                전세사기 알리미 구독하러 가기
                            </button>
                        </div>     
                    </div>
                </div>
            </section>
        </article>
    </div>
</template>
    
<script>

import '@/assets/css/common.css'




// import { mapActions } from 'vuex'
// import { mapState } from 'vuex'

import { alertBase } from '@/mixins/alert.js'

export default {
    name: 'FeedLoanView',
    components: {
        
    },
    data(){
        return{

        }
    },
    created() {

    },       
    computed: {

    },
    mounted() {
    },
    methods: {
        fnOrder(){
            this.$router.push('/subscribe');
        },
        fnCopy(){
            const $textarea = document.createElement("textarea");
            document.body.appendChild($textarea);
            $textarea.value = `${window.location.origin}/feed/alarm`;
            $textarea.select();

            document.execCommand('copy');
            document.body.removeChild($textarea);


            alert('주소가 복사되었습니다.');
        },                        
    },
    mixins: [alertBase]                     
}      

</script>
<style>
.loan_report_type03 {
    background: #FFF9F9;
    text-align: left;
    display: flex;
    padding: 11px 16px 0px 12px;
}
.loan_report_type03 > .check {
    margin-right: 11px;
}
.check_p  {
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
    text-align: justify;
    text-transform: lowercase;
    color: #3E3E3E;
    margin-bottom: 9px;
}

.grade_loan{
    background: conic-gradient(#ECECEC 0%, #ECECEC 20%, #FF5A56 20%, #FF5A56 100%);
    width: 164px;
    height: 164px;
    border-radius: 85px;
    /* border: 13px solid #FF5A56; */
    font-weight: 800;
    font-size: 50px;
    color: #FF5A56;
    display: flex;
    align-items: center;
    padding: 0 34px;
    line-height: 50px;
    margin: 30px auto;
    position: relative;
}
.center{
    background: #fff;
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    width: 140px;
    height: 140px;
    padding: 15px; 
    border-radius: 50%;
    text-align: center;
    font-size: 20px;
    transform: translate(-50%,-50%);
    font-weight: 800;
    font-size: 25px;
    color: #ff5a56;
}

.center_txt{
    z-index: 1;
    font-weight: 800;
    color:#FF5A56;
    /* font-family: 'NanumSquareRoundOTF'; */
    font-family: 'NanumSquareRound',sans-serif;
    font-style: normal;
}
</style>